var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.iconClass},[_c('svg',[_c('use',{attrs:{"xlink:href":_vm.iconFile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }